import { LayoutGrid, Workflow } from 'lucide-react';
import clsx from 'clsx';

// Переключатель модулей платформы. Сейчас два: BPM и Kanban.
// В будущем сюда добавятся Аналитика, AI Боты, Маркетинг.
const MODULES = [
  {
    id: 'bpm',
    label: 'BPM',
    href: 'https://bpm.danielsmln8n.ddnsgeek.com/',
    icon: Workflow,
    color: '#10b981',
  },
  {
    id: 'kanban',
    label: 'Kanban',
    href: 'https://kanban.danielsmln8n.ddnsgeek.com/',
    icon: LayoutGrid,
    color: '#5b5bd6',
  },
] as const;

export function ModuleSwitcher() {
  // Текущий модуль определяется по hostname
  const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';
  const activeId = currentHost.includes('bpm') ? 'bpm' : 'kanban';

  return (
    <div className="flex items-center gap-1 px-2 py-1.5 rounded-md bg-surface3-light dark:bg-surface3-dark">
      {MODULES.map((m) => {
        const Icon = m.icon;
        const isActive = m.id === activeId;
        return (
          <a
            key={m.id}
            href={m.href}
            className={clsx(
              'flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors',
              isActive
                ? 'bg-surface-light dark:bg-surface-dark shadow-sm font-medium'
                : 'opacity-60 hover:opacity-100',
            )}
            title={m.label}
          >
            <Icon size={13} style={{ color: m.color }} />
            <span>{m.label}</span>
          </a>
        );
      })}
    </div>
  );
}
